import {
    projectBplusPagePath
} from '@/pages/project-bplus/ProjectBplusPage.shared';

export const projectBplusModelPagePath = projectBplusPagePath + '/:modelSlug';